import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import { P_LOGO_URL } from "../lib/api";
import Nav from "../components/site/Nav";
import Footer from "../components/site/Footer";
import TypedSection from "../components/site/TypedSection";
import ContentError from "../components/site/ContentError";

export default function PageView() {
  const { slug } = useParams();
  const { content, loading, error, retry } = useContent();
  const page = content?.pages?.find((p) => p.slug === slug);

  useEffect(() => {
    if (page?.title) document.title = `${page.title} — Peça Business Solutions`;
  }, [page]);

  if (error && !content) return <ContentError onRetry={retry} />;

  if (loading || !content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-peca-black">
        <div className="flex flex-col items-center gap-4">
          <img src={P_LOGO_URL} alt="Peça" className="w-16 h-16 floaty" />
          <span className="label-mono text-peca-grey">A carregar…</span>
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="relative">
        <Nav content={content} solid />
        <div data-testid="page-not-found" className="min-h-screen flex flex-col items-center justify-center gap-6 px-5 text-center">
          <span className="font-mono-p text-peca-yellow text-6xl">404</span>
          <h1 className="font-display font-extrabold uppercase text-3xl md:text-5xl text-peca-cream">Página não encontrada</h1>
          <Link to="/" className="label-mono bg-peca-yellow text-peca-black px-6 py-3">Voltar ao início</Link>
        </div>
        <Footer content={content} />
      </div>
    );
  }

  const sections = (page.sections || []).filter((s) => s.visible !== false);

  return (
    <div data-testid={`page-${page.slug}`} className="relative">
      <Nav content={content} solid />
      <main className="pt-20">
        {sections.length === 0 ? (
          <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-40">
            <h1 className="font-display font-extrabold uppercase text-4xl md:text-6xl text-peca-cream">{page.title}</h1>
          </div>
        ) : (
          sections.map((s) => <TypedSection key={s.id} section={s} />)
        )}
      </main>
      <Footer content={content} />
    </div>
  );
}
